module.exports = __webpack_public_path__ + "static/sport/swiper-2.7ab2c48.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport4/swiper-2.png
// module id = 9l4U
// module chunks = 0